import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
  align = "left",
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end ${
        centered ? "md:flex-col md:items-center" : "md:justify-between"
      }`}
    >
      <div className={centered ? "text-center" : ""}>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-600">
            <span className="h-px w-6 bg-primary-500"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p
            className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 ${
              centered ? "mx-auto" : ""
            }`}
          >
            {description}
          </p>
        )}
      </div>
      {action}
    </div>
  );
}